import { Button, Modal, Progress, Text } from "@/ui";
import styles from "./ExportProgressModal.module.scss";

const ExportProgressModal = ({
    isOpen,
    progress,
    isCancelled,
    onCancel,
    onClose,
}) => {
    const canClose = isCancelled || progress === 100;

    return (
        <Modal
            footer={
                <div className={styles.footer}>
                    <Button
                        disabled={isCancelled || progress === 100}
                        onClick={onCancel}
                        type="button"
                    >
                        Cancel
                    </Button>
                </div>
            }
            onOpenChange={open => {
                if (!open && canClose) {
                    onClose();
                }
            }}
            open={isOpen}
            showCloseButton={canClose}
            size="sm"
            title="Exporting Customers"
        >
            <div className={styles.body}>
                <Text variant="body-md">
                    {isCancelled
                        ? "Export cancelled."
                        : "Please wait while we prepare your export..."}
                </Text>
                <div className={styles.progressBlock}>
                    <Progress
                        aria-label={`Export progress ${progress}%`}
                        fullWidth
                        value={progress}
                    />
                    <Text
                        className={styles.percent}
                        tone="secondary"
                        variant="body-sm"
                    >
                        {progress}%
                    </Text>
                </div>
            </div>
        </Modal>
    );
};

export default ExportProgressModal;
